
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paths/career/[path_slug]",
      function () {
        return require("private-next-pages/paths/career/[path_slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paths/career/[path_slug]"])
      });
    }
  